import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=08bf8a44"
import script from "./Introduce.vue?vue&type=script&lang=js"
export * from "./Introduce.vue?vue&type=script&lang=js"
import style0 from "./Introduce.vue?vue&type=style&index=0&id=08bf8a44&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports